import DataObject from '../../../common/model/DataObject';

export default class ContractAlert extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'isActive',
      'alertAudience',
      'alertImage',
      'replacePreviousAlert',
      'autoCloseIntervalSeconds',
    ];
  }
}